(() => {
  document.documentElement.classList.add('elcorvia-ready');
  document.querySelectorAll('.el-faq details').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      item.parentElement.querySelectorAll('details[open]').forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });
})();

